import { Box, Typography } from '@mui/material';

import { COLORS } from '@/styles/tokens/colors';

export interface StepIntroProps {
  title: string;
  subtitle: string;
}

/** The title + supporting line that opens each step's body. */
export function StepIntro({ title, subtitle }: StepIntroProps) {
  return (
    <Box mb={2}>
      <Typography variant="title-s" component="h2">
        {title}
      </Typography>
      <Typography
        display="block"
        variant="body-s"
        color={COLORS.TEXT.SECONDARY}
        mt={0.25}
      >
        {subtitle}
      </Typography>
    </Box>
  );
}
